import { useSearchParams } from 'react-router-dom';
import { OptionGroup, OptionItem } from '../pages/gallery/options';

export const useTagSearch = (options:any, illustrations: any[] = []) => {
const [searchParams, setSearchParams] = useSearchParams();


  //関数を定義するだけでなく、即座に実行して「counts」という変数に結果を入れる
  const counts: Record<string, number> = {};
  // 現在の検索ワードを取得
  const searchQuery = searchParams.get('q') || '';
  const yearParam = searchParams.get('y');
  const selectedYear = yearParam === "All" || !yearParam ? "All" : Number(yearParam);
  
  const activeTags = searchParams.get('tags')?.split(',') || [];


illustrations.forEach(item => {
    // Galleryから渡された baseFilteredList ですでに「検索」「年」は絞り込み済みですが、
    // ここで「選択中のタグをすべて持っているか」を判定に加えます
    const matchCurrentTags = activeTags.every((tagId: string) => 
      !tagId || item.tags.includes(tagId)
    );

    if (matchCurrentTags) {
      item.tags.forEach((tagId: string) => {
        counts[tagId] = (counts[tagId] || 0) + 1;
      });
    }
  });

  const optionsWithCounts = options.map((group: any) => ({
    ...group,
    options: group.options.map((opt: any) => ({
      ...opt,
      label: `${opt.label} (${counts[opt.value] || 0})`
    }))
  }));

  
  const currentTags = activeTags;

  const displayTags = currentTags.map(tagId => {
    const found = options.flatMap((g: OptionGroup) => g.options).find((o: OptionItem) => o.value === tagId);
    return { value: tagId, label: found?.label || tagId };
  });

  const handleChange = (selected: any) => {
    const values = selected ? selected.map((opt: any) => opt.value) : [];
    setSearchParams(values.length ? { tags: values.join(',') } : {});
  };

  //年検索
    const handleYearChange = (year: number | "All") => {
      const newParams = new URLSearchParams(searchParams);
      if (year === "All") {
        newParams.delete('y'); // 「すべての年」ならURLから消す
      } else {
        newParams.set('y', year.toString()); // 年をURLにセット
      }
      setSearchParams(newParams);
    };


  //キーワード検索

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const newParams = new URLSearchParams(searchParams);
    
    if (value) {
      newParams.set('q', value);
    } else {
      newParams.delete('q');
    }
    setSearchParams(newParams);
  };

  // 最後に Gallery.tsx で使いたいものを全部返す
  return { 
    displayTags, handleChange, currentTags, searchQuery,handleSearchChange ,optionsWithCounts,counts,selectedYear, handleYearChange};

};